import 'date-fns';
import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { TranslationsContext } from '../../../config/translations';
import { makeStyles } from '@material-ui/core';
import { cancelLabel, clearLabel, localeMap } from '../../../utils/datefns-locale';

const useStyles = makeStyles(theme => ({
  regularDatePickerWrapper: {
    '& div.Mui-error > input': {
      padding: 0,
    },
    '& p.Mui-error': {
      margin: theme.spacing(0, 0, 0, 1),
    },
  },
  dateTimePickerWrapper: {
    width: 220,
    margin: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      margin: 'auto',
    },
  },
  dateTimePicker: {
    width: '100%',
  },
}));

const datePicker = (label, field, form, extraHandleChangeAction, disabled, invalidDateMessage) => {
  const currentError = form.getFieldMeta(field.name).error;
  
  return (
    <KeyboardDatePicker
      autoOk
      clearable
      disabled={disabled}
      invalidDateMessage={invalidDateMessage}
      label={label}
      value={field.value ? field.value : null}
      onChange={(date) => {
        form.setFieldValue(field.name, date ? date : null);
        if (extraHandleChangeAction) {
          extraHandleChangeAction();
        }
      }}
      onError={(error) => {
        if (error && error !== currentError) {
          form.setFieldError(field.name, error);
        }
      }}
      helperText={currentError}
      error={Boolean(currentError)}
      cancelLabel={cancelLabel}
      clearLabel={clearLabel}
      format="yyyy-MM-dd"
    />
  );
};

const dateTimePicker = (label, field, form, classes, disabled, invalidDateMessage) =>
  <KeyboardDateTimePicker
    autoOk
    clearable
    disabled={disabled}
    invalidDateMessage={invalidDateMessage}
    ampm={false}
    className={classes.dateTimePicker}
    value={field.value ? field.value : null}
    onChange={(date) => {
      form.setFieldValue(field.name, date ? date : null);
    }}
    onError={(error) => {
      if (error && form.errors && !form.errors[field.name]) {
        form.setFieldError(field.name, error);
      }
      if (!error && form.errors && form.errors[field.name]) {
        form.setFieldError(field.name, undefined);
      }
    }}
    label={label}
    cancelLabel={cancelLabel}
    clearLabel={clearLabel}
    format="yyyy-MM-dd HH:mm"
    KeyboardButtonProps={{ style: { display: disabled && 'none' } }}
  />;

const CommonDatePicker = ({ label, form, field, withTime, extraHandleChangeAction, disabled, invalidDateMessage }) => {
  const classes = useStyles({ disabled: disabled });
  
  const renderDatePicker = withTime ?
    dateTimePicker(label, field, form, classes, disabled, invalidDateMessage)
    : datePicker(label, field, form, extraHandleChangeAction, disabled, invalidDateMessage);
  
  return (
    <TranslationsContext.Consumer>
      {({ languageState }) =>
        <div
          className={`${withTime ? classes.dateTimePickerWrapper : classes.regularDatePickerWrapper} dateTimePickerWrapper`}>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[languageState]}>
            {renderDatePicker}
          </MuiPickersUtilsProvider>
        </div>
      }
    </TranslationsContext.Consumer>
  );
};

export default CommonDatePicker;